// extracted by mini-css-extract-plugin
export default {"addToCartControl":"W1-z","giftCard":"X1-z","btnContainer":"Y1-z","cartButton":"Z1-z","disabled":"_1-z"};